import { IFlags } from "flagsmith/src/types"

export type FlagOptions = "test"

export const flagSmithDefaultFlags: IFlags<FlagOptions> = {
    test: { enabled: false },
}
